import ReactDOM from "react-dom/client";
import { ComponentLegacy } from "desktop/LegacyDesktop";
import reportWebVitals from "reportWebVitals";

import { UnconnectedErrorBoundary as ErrorBoundary } from "shared/components/ErrorBoundary";

import "i18n";

ReactDOM.createRoot(document.getElementById("terms_title")).render(
  <ErrorBoundary>
    <ComponentLegacy />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
